import request from '@hb/sharp-request';
import { newGatewayUrl } from '@/constant';

// 获取渠道产品配置信息
export const getCommodityConfig = (
  commodityId: string,
  keys: string | string[],
  capitalCode?: string,
): Promise<{ [key: string]: string }> => request.postGate('f.commodity.config.items', {
  commodityId,
  // 临时只支持string，后端需要通过 keys=a&keys=b 传递，不支持解析 keys[]=a&keys[]=b 的形式
  keys: [keys], // isString(keys) ? [keys] : keys
  capitalCode,
},
{
  baseURL: newGatewayUrl,
});

const CommodityApi = {
  getCommodityConfig,
};

export default CommodityApi;
